import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Nav from '../src/frontend/landing/nav'; // Adjust the import path as needed

const ProtectedLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
      setMenuOpen(!menuOpen);
  };

  return (
    <div>
      <Nav menuOpen={menuOpen} toggleMenu={toggleMenu} />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default ProtectedLayout;